import { render } from "./Calendar.vue?vue&type=template&id=65c023f6&scoped=true&ts=true"
import script from "./Calendar.vue?vue&type=script&lang=ts"
export * from "./Calendar.vue?vue&type=script&lang=ts"

import "./Calendar.vue?vue&type=style&index=0&id=65c023f6&scoped=true&lang=css"

import exportComponent from "/var/www/mj-root/fe-site-manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c023f6"]])

export default __exports__